import { useEffect, useState } from 'react'
import {
  useActiveFeatureFlags,
  useFeatureFlagEnabled,
  usePostHog,
} from 'posthog-js/react'
import type { FeatureFlag } from '@/shared/constants/feature-flags'

export function useFeatureEnabled(flag: FeatureFlag): boolean | undefined {
  const posthog = usePostHog()
  const enabled = useFeatureFlagEnabled(flag)
  const [loaded, setLoaded] = useState(
    () => posthog.featureFlags.hasLoadedFlags,
  )

  useEffect(() => posthog.onFeatureFlags(() => setLoaded(true)), [posthog])

  if (!loaded) return undefined
  return !!enabled
}

export function useFeatureFilter<T extends { flag?: FeatureFlag }>(
  items: T[],
): T[] {
  const activeFlags = useActiveFeatureFlags()
  return items.filter((item) => !item.flag || activeFlags.includes(item.flag))
}
